import pinia from '@/stores/index';
import { useStore } from '@/stores/store';
import { Session } from '@/utils/storage';
import { useTagsViewRoutes } from '@/stores/tagsViewRoutes';
import { useThemeConfig } from '@/stores/themeConfig';
import { useKeepALiveNames } from '@/stores/keepAliveNames';
import { storeToRefs } from 'pinia';
import { computed, reactive} from 'vue'; 
export const store = useStore(pinia); 
const storesTagsViewRoutes = useTagsViewRoutes();
const storesKeepALiveNames = useKeepALiveNames();
const storesThemeConfig = useThemeConfig();
const { themeConfig } = storeToRefs(storesThemeConfig);
const getThemeConfig = computed(() => {
	return themeConfig.value;
}); 
// const state = reactive<TagsViewState>({
// 	routeActive: '',
// 	routePath: '',
// 	dropdown: { x: '', y: '' },
// 	sortable: '',
// 	tagsRefsIndex: 0,
// 	tagsViewList: [],
// 	tagsViewRoutesList: [],
// });
export function getRouteInfo(pagename: string) {
  if (!store.state.app.menudata || !store.state.app.menudata.data || store.state.app.menudata.data.length === 0)
    return '';     
  let menulst = store.state.app.menudata.data;  
  var routeinfo = { path: '', name: '', title: '' };
  var result:any =null;
  if (!menulst.length || menulst.length==0)
  return routeinfo;
  for (let i1 = 0; i1 < menulst.length; i1++) {
    if (menulst[i1].meta.pagename === pagename) {        
      routeinfo.name = menulst[i1].name;
      routeinfo.path = menulst[i1].path;
      routeinfo.title = menulst[i1].meta.title;     
      return routeinfo;
    }
    if (menulst[i1].children.length > 0) {
      result = findRouteInfo(menulst[i1].children, pagename)
      if (result!==null)
        return result;
    }
  }
  return null;
}
function findRouteInfo(menulst: any, pagename: string): any {
  var routeinfo = { path: '', name: '', title: '' };
  var result:any=null;
  for (let i1 = 0; i1 < menulst.length; i1++) {
    if (menulst[i1].meta.pagename === pagename) {         
      routeinfo.name = menulst[i1].name;
      routeinfo.path = menulst[i1].path;
      routeinfo.title = menulst[i1].meta.title;      
      return routeinfo;
    }
    if (menulst[i1].children.length > 0) {      
      result = findRouteInfo(menulst[i1].children, pagename)
      if (result!==null)
        return result;
    }
  }
  return null;
} 
export function getTagsView(path: string) {    
  var decodeURIPath = decodeURI(path);
  decodeURIPath=decodeURIPath.replace('?tagsViewName=','-')
  decodeURIPath=decodeURIPath.replace('&id=','')
  decodeURIPath=decodeURIPath.replace('&coper=','')  
  return decodeURIPath;
}

